import { Component, Input, OnInit, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Block, BlockType } from '@app/@models/brochure-content.model';
import { GoogleAnalyticsCategory, GoogleAnalyticsEvents } from '@app/@models/constants';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';

@Component({
  selector: 'pl-modal-content-card-single',
  templateUrl: './modal-content-card-single.component.html',
  styleUrls: ['./modal-content-card-single.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalContentCardSingleComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private gaService: GoogleAnalyticsService = inject(GoogleAnalyticsService);

  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public blocks: Block[] = [];

  public BlockType: typeof BlockType = BlockType;

  public close(): void {
    this.activeModal.dismiss();
  }

  public ngOnInit(): void {
    this.gaService.event(GoogleAnalyticsEvents.openModalToLearnMore, {
      category: GoogleAnalyticsCategory.userNavigation,
      label: this.title,
    });
  }
}
